<template>
  <div>

    <!-- collapse -->
    <app-collapse
        accordion
        type="margin"
        class="mt-2"
    >
      <app-collapse-item
          v-for="(sheet, index) in items"
          :key="index"
          :title="sheet.CreatedAt | date"
      >

        <template #status>
          <b-badge
              variant="light-primary"
              v-if="sheet.Status == 1"
          >
            تایید شده
          </b-badge>
          <b-badge
              variant="light-secondary"
              v-if="sheet.Status == 0"
          >
            در انتظار بررسی
          </b-badge>
        </template>

        <div v-for="(data, index) in sheet.UserQuestionAnswer" style="border: 1px solid #4b465c1f; border-radius: 0.5rem; padding: 1rem; margin-bottom: 1rem">

          <div style="margin-bottom: 1rem;">
            {{ data.Question.Title }}
          </div>

          <div v-if="data.Description" style="background: #f6f6f7; padding: 0.5rem 1rem; margin-bottom: 1rem; border-radius: 0.5rem;">
            {{ data.Description }}
          </div>

          <b-form-checkbox
              v-if="data.Question.QuestionOption"
              v-for="(questionOption, index) in data.Question.QuestionOption"
              :checked="data.UserQuestionAnswerOption.filter(x=>x.QuestionOptionId == questionOption.Id).length > 0"
              class="custom-control-primary"
              :disabled="true"
          >
            {{ questionOption.Title }}
          </b-form-checkbox>

          <div v-if="data.UserQuestionAnswerAttachment">
            <div
                v-for="(userQuestionAnswerAttachment, index) in data.UserQuestionAnswerAttachment"
                :key="index"
            >
              <b-avatar
                  v-if="isImage(userQuestionAnswerAttachment.Url)"
                  :src="userQuestionAnswerAttachment.Url"
                  :id="userQuestionAnswerAttachment.Url"
                  size="104px"
                  rounded
                  button
                  style="margin-left: 1rem; margin-top: 1rem;"
                  @click="showFilePreview(userQuestionAnswerAttachment.Url)"
              />
              <b-avatar
                  v-else
                  :href="userQuestionAnswerAttachment.Url"
                  :id="userQuestionAnswerAttachment.Url"
                  size="104px"
                  rounded
                  style="margin-left: 1rem; margin-top: 1rem;"
              >
                <feather-icon icon="FileTextIcon" size="40" />
              </b-avatar>
            </div>
          </div>

        </div>

        <div class="mt-1 mb-2 text-right">
          <b-button
              v-if="sheet.Status == 0"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              @click="showModal(sheet)"
          >
            تایید
          </b-button>
          <b-button
              v-if="sheet.Status == 1"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="outline-warning"
              @click="showModal(sheet)"
          >
            لغو تایید
          </b-button>
        </div>

      </app-collapse-item>

    </app-collapse>

    <!--/ collapse -->

    <b-modal
        v-model="isShow"
        v-if="isShow"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        modal-class="confirm-pay-modal"
        title="تایید پاسخنامه"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="save"
    >
      <div>
        پاسخنامه مورد نظر بسته شود؟
      </div>
    </b-modal>
    <b-modal
        v-model="showPreview"
        v-if="showPreview"
        ok-title="تایید"
        cancel-title="بازگشت"
        cancel-variant="outline-secondary"
        centered
        size="sm"
        @ok="showPreview = false"
    >
      <img :src="filePreview" alt="" class="w-100" />
    </b-modal>
  </div>
</template>

<script>

import { BAvatar } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import userQuestionAnswer from "@/modules/apies/user/userQuestionAnswer";

export default {
  name: "UserQuestionAnswer",
  components:{
    BAvatar,
    AppCollapseItem,
    AppCollapse,
  },
  props: {
    userId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      row: null,
      isShow: false,
      showPreview: false,
      filePreview: null
    }
  },
  created() {
    this.get()
  },
methods: {
  get() {
    this.loading = true
    this.$http.post(
        this.$api.userQuestionAnswerSheet.getall, {
          UserId: this.userId,
        },
    )
        .then(res => {
          this.loading = false
          this.items = res.data
        })
  },
  showModal(row) {
    this.row = row
    this.isShow = true
  },
  save(){
    this.loading = true
    this.$http.post(
        this.$api.userQuestionAnswerSheet.update, {
          Id: this.row.Id,
          Status: !this.row.Status
        },
    )
        .then(res => {
          this.loading = false
          this.row.Status = !this.row.Status
          this.$emit('User')
        })
  },
  isImage(file) {
    const validImageTypes = ['gif', 'jpeg', 'png', 'svg', 'jpg'];
    let fileType = file.split('.').pop()
    return validImageTypes.includes(fileType)
  },
  showFilePreview(file) {
    this.filePreview = file
    this.showPreview = true
  }
}
}
</script>

<style scoped>

</style>